module.exports = __webpack_public_path__ + "static/evolution-02609166577404418a4313515397297b.png";